import { useEkardoMutation } from '@netfront/ekardo-content-library';

import { DELETE_SUMMARY_FEEDBACK_ITEM } from './UseDeleteSnippetSummaryFeedbackConfigItem.graphql';

const useDeleteSnippetSummaryFeedbackConfigItem = (options) => {
  const { mutation, onCompleted, onError, token } = options ?? {};

  const [executeDeleteSnippetSummaryFeedbackConfigItem, { loading: isLoading }] = useEkardoMutation({
    mutation: mutation ?? DELETE_SUMMARY_FEEDBACK_ITEM,
    options: {
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          summaryFeedback: { deleteSummaryFeedbackConfiguration: isCompleted },
        } = data;

        onCompleted({
          isCompleted,
        });
      },
      onError,
    },
    token,
  });

  const handleDeleteSnippetSummaryFeedbackConfigItem = ({ variables }) => {
    executeDeleteSnippetSummaryFeedbackConfigItem({
      variables,
    });
  };

  return {
    handleDeleteSnippetSummaryFeedbackConfigItem,
    isLoading,
  };
};

export { useDeleteSnippetSummaryFeedbackConfigItem };
